/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import BaseObject from "@shared/BaseObject";
import {RecurrenceType} from "@shared/Recurrence/RecurrenceEnums";

export default class RecurrencePatternItem extends BaseObject{


	type: RecurrenceType = RecurrenceType.WEEKLY
	interval: number = 1
	daysOfWeek: boolean[] = [false, false, false, false, false, false, false] // represents checked days of the week. First index represents Monday
	dayOfMonth: number = null
	month: number = null

	constructor() {
		super();
	}

	reset(){
		this.daysOfWeek = [false, false, false, false, false, false, false]
	}


	numberOfSelectedDays(){
		let count = this.daysOfWeek.reduce((sum, isSelected) => sum + (isSelected ? 1 : 0), 0)
		return count
	}

	// equals(other){
	// 	if(!other){
	// 		console.log("RecurringPatternItem.equals = false: other is null")
	// 		return false
	// 	}
	// 	if(other.type != this.type){
	// 		console.log("RecurringPatternItem.equals = false: type changed")
	// 		return false
	// 	}
	// 	if(other.interval != this.interval){
	// 		console.log("RecurringPatternItem.equals = false: interval changed")
	// 		return false
	// 	}
	// 	if(other.dayOfMonth != this.dayOfMonth){
	// 		console.log("RecurringPatternItem.equals = false: dayOfMonth changed")
	// 		return false
	// 	}
	// 	if(other.month != this.month){
	// 		console.log("RecurringPatternItem.equals = false: month changed")
	// 		return false
	// 	}
	// 	if(!other.daysOfWeek || other.daysOfWeek.length != 7){
	// 		console.log("RecurringPatternItem.equals = false: daysOfWeek incorrect")
	// 		return false
	// 	}
	//
	// 	for(let i = 0; i < 7; ++i){
	// 		if(other.daysOfWeek[i] != this.daysOfWeek[i]){
	// 			console.log("RecurringPatternItem.equals = false: daysOfWeek changed, dayIndex = ", i)
	// 			return false
	// 		}
	// 	}
	//
	//
	// 	return true
	// }



}



